// extracted by mini-css-extract-plugin
export default {"cardHeader":"DepartmentManagement_cardHeader__+R1yQ","cardHeaderIcon":"DepartmentManagement_cardHeaderIcon__5d5hq","createButton":"DepartmentManagement_createButton__UaKOd"};